import '../css/index.scss';
import MenuBar from './components/menuBar';
import './components/banner';
import CartDrawer from './components/cartDrawer';
// import { initializeCart } from './updateCart';
import Footer from './components/footer';
import Captcha from './page/captcha';
import Bundle from './page/bundle';
import Byok from './page/byok';
import Home from './page/home';
import Blog from './blog/home';
import BlogArticle from './blog/article';
import BlogCategory from './blog/category';
import Plp from './page/plp';
import Pdp from './page/pdp';
import Cart from './page/cart';
import AboutUs from './page/aboutUs';
import OurPeople from './page/ourPeople';
import Login from './page/login';
import Register from './page/register';
import ResetPassword from './page/resetPassword';
import FAQsPage from './page/faqs';
import ContactPage from './page/contact';
import ParallaxController from './components/parallax/parallaxController';
import CustomersAccount from './page/customers/account';
import AddressesPage from './page/customers/addresses';
import ErrorPage from './components/404';
import './page/product/reviews-add-product-title';
import './page/blog/nav-mobile';
import './page/blog/load-more';
import './page/blog/section-blog';
import './page/blog/nav-switch-colors';
import './page/article/related-products-slider';
import './page/article/related-products-quick-view';
import './components/article-item';
import './components/calculateHeader';
import './components/slider-womens';
import './components/popup-cookie';
import './components/nav-mobile';
import './components/checkout';


document.addEventListener('DOMContentLoaded', e => {
  const menuBar = new MenuBar();
  const cartDrawer = new CartDrawer();
  const footer = new Footer();
  const parallaxController = new ParallaxController('.parallax');
  const aboutUs = new AboutUs();
  const captcha = new Captcha();

  // window.initializeCart = initializeCart;

  if(document.querySelector('.js-buddle-products')){
    const bundle = new Bundle();
    console.log('Bundle')
  }

  if (document.querySelector('.js-byok-products')) {
    const byok = new Byok();
    console.log('Byok')
  };

  // Home
  document.body.classList.contains('index') && new Home();

  // PLP
  document.body.className.indexOf('collection') >= 0 && new Plp();

  // Product
  (document.body.classList.contains('product') || document.body.classList.contains('product-trial')) && new Pdp();

  // Cart
  document.body.classList.contains('cart') && new Cart();

  // Login
  document.body.classList.contains('customers-login') && new Login();

  // Register
  document.body.classList.contains('customers-register') && new Register();

  // Reset Password
  document.body.classList.contains('customers-reset_password') && new ResetPassword();

  // Our People
  document.body.classList.contains('page-our-people') && new OurPeople();

  // FAQs
  document.body.classList.contains('page-faq') && FAQsPage();

  // Contact
  document.body.classList.contains('page-contact') && ContactPage();

  // Customer Account
  document.body.classList.contains('customers-account') && CustomersAccount();

  // Customer Addresses
  document.body.classList.contains('customers-addresses') && AddressesPage();

  // 404
  document.body.classList.contains('template-404') && new ErrorPage();

  // Blog
  if(document.querySelector('.blog-category')){
    new BlogCategory();
  }
  document.body.classList.contains('article-greek') && new BlogArticle();
  document.body.classList.contains('blog-greek') && new Blog();
});

